<template>
  <Comments :params="params" :key="version" />
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import Comments from "@/modules/comments/pages/comments/components/comments/Comments"

export default defineComponent({
  name: "PromopushkaComments",
  components: {
    Comments
  },
  setup() {
    let version = ref(0)

    let params = {
      title: "Комментарии в Промопушке",
      h1: "Комментарии в Промопушке",
      page: "promopushka_comments",
      channels: [13],
    }

    onMounted(() => {
      version.value++
    })

    return {
      params,
      version,
    }
  }
})
</script>

<style scoped>

</style>
